define([
	"dojo/_base/declare",
	"dojo/dom-geometry",
	"csi/dojoExtensions",
	"csi/html",
	"./util"
], function(declare,geometry,dojoExtensions,html,util) {

	return declare(null, {
		// Event: original event
		e: null,

		// Boolean: indicates if mouse is over canvas editor
		overEditor: false,

		// Boolean: indicates if mouse is over SVG node
		overSvg: false,


		constructor: function(/*Event*/e, /*SvgCanvasEditor*/editor, /*Boolean*/bDrag) {
			const insertNode = editor.insertNode;
			const mb = geometry.getMarginBox(insertNode);
			const p = geometry.position(insertNode);
			const mx = e.pageX;
			const my = e.pageY;
			const x = mx - p.x;
			const y = my - p.y;
			const zoomFactor = editor.canvasApp.selection.getZoomFactor();

			this.e = e;

			// track if mouse not over canvas
			if (!dojoExtensions.hasAnyPopups()) {
				this.overEditor = html.mouseInNode(mx, my, editor.view.canvasContainerNode) && !html.mouseInNode(mx, my, editor.view.rightNode);
				this.overSvg = this.overEditor && (x >= 0) && (x <= (mb.w * zoomFactor) && (y >= 0) && (y <= (mb.h * zoomFactor)));
			}
		},

		alt: function() {
			// summary: return if ctrl key pressed
			return this.e.altKey;
		},

		ctrl: function() {
			// summary: return if ctrl key pressed
			return this.e.ctrlKey || this.e.metaKey;
		},

		shift: function() {
			// summary: return if ctrl key pressed
			return this.e.shiftKey;
		},

		key: function() {
			// summary: return key pressed
			return this.e.keyCode;
		},

		target: function() {
			// summary: Chrome SVG events on use element are forwarded to the definition, so detect
			// this case to return the use element
			var	node = this.e.target;
			return node.correspondingUseElement || node;
		}
	});
});
